<div class="lti-thanks">

  <a routerLink="/" class="lti-thanks-logo">
    <img src="assets/images/LTI-logo-white-v2.png" alt="LetsTimeIt" class="lti-brand-logo">

  </a>

  <div class="lti-thanks-card">
    <div class="lti-thanks-icon">
      <mat-icon>check_circle</mat-icon>
    </div>
    <h1 class="lti-thanks-title">Thanks. See you again.</h1>
    <p class="lti-thanks-sub">You're all set. Come back any time to manage your events and timers.</p>
    <a routerLink="/" class="lti-thanks-btn">Back to sign in</a>
  </div>

  <div class="lti-thanks-footer">© 2026 LetsTimeIt Inc.</div>

</div>
